import { Button, FormLabel, Heading, Input } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from '@tanstack/react-form'
import { Textarea, FormControl } from '@chakra-ui/react'
import { Manufacturer } from "../../models/manufacturer";
import { useFetch } from "../../contexts/FetchContext";
import { Sandbox } from "../../models/sandbox";
import { useFormKeyBindings } from "../../components/Helpers/useFormKeyBindings";
import { FormModal } from "../../components/Helpers/FormModal";

export const CreateSandbox = () => {
  const [isLoading, setLoading] = useState<boolean>(true);
  const [manufacturer, setManufacturer] = useState<Manufacturer>();

  const navigate = useNavigate()
  const { backend } = useFetch();

  const refetch = () => {
    setLoading(true)
    backend.manufacturers.get()
      .then((data) => {
        /* Må FIKSES */
        const sandBoxManufacturer = data.find(manufacturer => manufacturer.name === "Sandbox")
        if (sandBoxManufacturer) {
          setManufacturer(sandBoxManufacturer)
        } else {
          onClose()
        }
        setLoading(false)
      });
  }

  useEffect(() => {
    refetch()
  }, []);

  const onClose = () => {
    navigate(-1);
  };

  const form = useForm({
    defaultValues: {
      manufacturer: '',
      model: '',
      description: '',
      name: '',
      alias: '',
      mail: '',
    },
    onSubmit: async (values) => {
      if (await form.validateAllFields("submit")) {
        const sandbox: Sandbox = {
          description: values.description,
          rentStatus: null,
          id: 0,
          name: values.name,
          alias: values.alias,
          mail: values.mail,
          deleted: new Date(),
          rentHistory: [],
        }
        backend.sandboxes.create(
          sandbox
        ).then((response) => {
          onClose();
        }).catch((error) => {
          console.log(error)
        });
      }
    }
  })

  useFormKeyBindings({
    handleSubmit: form.handleSubmit,
    handleClose: onClose,
    canSubmit: form.state.canSubmit,
    isSubmitting: form.state.isSubmitting
  });


  const FormFields = [
    (
      <form.Field
        name="name"
        onChange={
          (value) => {
            return !value || value.length === 0
              ? 'Name is required'
              : undefined
          }
        }
        children={field => {
          return (
            <FormControl isInvalid={field.state.meta.errors.length > 0}>
              <FormLabel>Name</FormLabel>
              <Input
                autoFocus
                variant='filled'
                type="string"
                name={field.name}
                value={field.state.value}
                onBlur={field.handleBlur}
                onChange={(e) => field.handleChange(e.target.value)}
                placeholder="Name"
                required

              />
            </FormControl>
          )
        }}
      />
    ),
    (
      <form.Field
        name="alias"
        onChange={
          (value) => {
            return !value || value.length === 0
              ? 'Alias is required'
              : undefined
          }
        }
        children={field => {
          return (
            <FormControl isInvalid={field.state.meta.errors.length > 0}>
              <FormLabel>Alias</FormLabel>
              <Input
                variant='filled'
                required
                name={field.name}
                value={field.state.value}
                onBlur={field.handleBlur}
                onChange={(e) => field.handleChange(e.target.value)}
                placeholder="Alias"
              />
            </FormControl>
          )
        }}
      />

    ), (
      <form.Field
        name="mail"
        children={field => {
          return (
            <FormControl>
              <FormLabel>Mail</FormLabel>
              <Input
                variant='filled'
                type="email"
                required
                name={field.name}
                value={field.state.value}
                onBlur={field.handleBlur}
                onChange={(e) => field.handleChange(e.target.value)}
                placeholder='Mail'
              />
            </FormControl>
          )
        }}
      />
    ), (
      <form.Field
        name="description"
        children={field => {
          return (
            <FormControl>
              <FormLabel>Desciption</FormLabel>
              <Textarea
                name="description"
                value={field.state.value}
                onChange={(e) => field.handleChange(e.target.value)}
              />
            </FormControl>
          )
        }}
      />
    )
  ]

  const SubmitButton = () => {
    return (
      <Button colorScheme='blue' isLoading={form.state.isSubmitting} type="submit" disabled={!form.state.canSubmit}>
        Create
      </Button>
    )
  }

  const Header = () => {
    return (
      <>
        <Heading size='xl' mt={5}>New Sandbox</Heading>
      </>
    )
  }

  return (
    <FormModal
      isLoading={manufacturer ? true : false}
      headerElements={[<Header />]}
      form={form}
      formFields={FormFields}
      SubmitButton={<SubmitButton />}
      onClose={onClose}
    />
  )
}
